import {connect} from 'react-redux'
import PublicTournamentsAnsicht from "../../../../components/views/public/tournamentsneu/PublicTournamentsAnsicht";

const mapStateToProps = function (state, ownProps) {
    return {isLoggedIn: state.user.isLoggedIn,};
};

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PublicTournamentsAnsicht)
